import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

export default {
  inserted(el) {
    el.style.position = "relative";
    el &&
      new PerfectScrollbar(el, {
        wheelSpeed: 2,
        wheelPropagation: false,
      });
  },
};
